<template>
    <div v-if="user">

        <va-page-header>

            <div slot="title">
                <span :key="catKey" v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager')"
                    :class="{edit_title: true, edit_title_cat: true}" @click="showCategoryModal">
                    {{ g_getLabel(getCategory)}}
                    <va-icon style="zoom: 0.9; margin-left: 10px" color="#999" type="pencil-alt">
                    </va-icon>
                </span>
                <span class="edit_title_cat" :key="catKey"
                    v-else>{{ user && !user.get('roles').includes('guest') ? g_getLabel(getCategory) : 'Your surveys' }}</span>
            </div>

            <div slot="actions">
                <va-button
                    v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor')"
                    @click.native="navigate('/surveys/' + $route.params.scope + '/' + $route.params.category + '/form/new', null)"
                    style="position: absolute; right: 22px; top: 20px;" type="primary" size="lg">
                    {{ _('NEW SURVEY') }}</va-button>
            </div>

        </va-page-header>

        <category :key="category_key" v-if="makeCategoryModalVisible" :class="{click: disableScreen}"
            v-on:hide-modal="hideCategoryModal" v-on:disable-screen="setDisableScreenValue" :title="'Survey Category'"
            :department="categoryDepartment" :category_for_update="getCategory" :can_delete="true"
            v-on:reload="fetchings" />

        <div>
            <va-row :gutter="12">
                <va-column :lg="12" :md="12" :sm="12">
                    <va-table hover fullWidth class="datatable" style="overflow: visible">
                        <table :dir="getDirectionStatus">
                            <thead>
                                <tr>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Name') }}</th>
                                    <th v-if="getScreenWidth > 425"
                                        :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Submitters') }}
                                    </th>
                                    <th v-if="getScreenWidth > 425"
                                        :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Created By')
                                        }}</th>
                                    <th v-if="getScreenWidth > 425"
                                        :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Date') }}</th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Status') }}</th>
                                    <th v-if="user && !user.get('roles').includes('guest') && getScreenWidth > 425"
                                        :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Design')
                                        }}</th>
                                    <th v-if="user && !user.get('roles').includes('guest')"
                                        :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Actions') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- v-if="!isSearching" -->
                                <tr v-if="allSurveysCount !== 0" v-for="(survey, index) in getSurvyes">
                                    <td v-if="!user.get('roles').includes('guest')"
                                        :class="{rtlTd: getSystemLanguage != 'english', fixed_td: true}"
                                        style="max-width: 200px">
                                        <!-- submissions -->
                                        <a v-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor') || user.get('roles').includes('submitter') || user.get('roles').includes('submission-approver') || user.get('roles').includes('survey-viewer')) && survey.get('status') != 'pending'"
                                            style="cursor:pointer"
                                            @click="navigate('/surveys/' + $route.params.scope + '/' + $route.params.category + '/' + survey.get('class_name').slice(5) + '/list?perPage=10', survey)">
                                            {{ g_getLabel(survey) }}</a>

                                        <!-- form design -->
                                        <a v-else-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor') || user.get('roles').includes('survey-viewer') || user.get('roles').includes('survey-approver') ) && survey.get('status') == 'pending'"
                                            style="cursor:pointer"
                                            @click="navigate('/surveys/' + $route.params.scope + '/' + $route.params.category + '/form/' + survey.id, survey)">
                                            {{ g_getLabel(survey) }}</a>

                                        <a v-else-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor') ||  user.get('roles').includes('survey-viewer')|| user.get('roles').includes('surveys')) && survey.get('status') != 'pending'"
                                            style="cursor:pointer" @click="navigate('/surveys/' + survey.id, survey)">
                                            {{ g_getLabel(survey) }}</a>
                                    </td>

                                    <td v-else-if="user.get('roles').includes('guest')" style="max-width: 200px"
                                        :class="{rtlTd: getSystemLanguage != 'english', fixed_td: true}">
                                        <a v-if="survey.get('status') != 'pending'" style="cursor:pointer"
                                            @click="navigate('/surveys/' + $route.params.scope + '/' + $route.params.category + '/' + survey.get('class_name').slice(5) + '/list?perPage=10', survey)">
                                            {{ g_getLabel(survey) }}</a>
                                        <span v-else>{{ g_getLabel(survey) }}</span>
                                    </td>
                                    <td v-if="getScreenWidth > 425" :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <div style="display: flex;">
                                            <div style=" margin-left: 10px" v-if="survey.get('survey_submitters')">
                                                <va-tooltip
                                                    v-for="(submitter, index) in survey.get('survey_submitters').slice(0, 3)"
                                                    :content="submitter.get('name')" trigger="hover" placement="top">
                                                    <img width="30px" height="30px"
                                                        style="display:inline-block; margin-left: -10px; border-radius: 100px; border:1px solid #fff;"
                                                        v-if="submitter.get('profilePic')"
                                                        :src="submitter.get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')" />
                                                </va-tooltip>
                                            </div>
                                            <div class="dropdown1"
                                                v-if="survey.get('survey_submitters') && survey.get('survey_submitters').length != 0">

                                                <va-dropdown v-if="survey.get('survey_submitters').length > 3">
                                                    <div style=" margin-left: 10px">
                                                    </div>
                                                    <div slot="trigger">
                                                        <span
                                                            style="display:inline-block; line-height: 27px; text-align: center; margin-left:-5px; background:#d8d8d8; border:1px solid #fff; border-radius: 15px; width:30px; height:30px;">...</span>
                                                    </div>
                                                    <div style="padding: 10px; min-width: 350px;">
                                                        <div v-for="(submitter, index) in survey.get('survey_submitters')"
                                                            style="margin: 5px 0">
                                                            <va-row :gutter="0">
                                                                <va-column :lg="12" :md="12" :sm="12" :xs="12">
                                                                    <div style="position: relative;">

                                                                        <div>
                                                                            <img width="35px" height="35px"
                                                                                style="margin-right: 10px; border-radius: 100px;"
                                                                                :src="submitter.get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')">
                                                                            <span
                                                                                :class="{ltrName: true, rtlName: getDirectionStatus == 'rtl'}">{{
                                                                                    submitter.get('name')}}</span>
                                                                            <span style="color: gray"
                                                                                :class="{ltrUsername: true, rtlUsername: getDirectionStatus == 'rtl'}">{{submitter.get('username')}}</span>
                                                                        </div>

                                                                        <div>

                                                                        </div>
                                                                    </div>
                                                                </va-column>
                                                            </va-row>
                                                            <hr>
                                                        </div>
                                                    </div>
                                                </va-dropdown>
                                            </div>
                                            <va-lozenge v-else type="default" bold>{{_("No Submitters")}} </va-lozenge>
                                        </div>

                                    </td>

                                    <td v-if="getScreenWidth > 425">
                                        <va-tooltip v-if="survey.get('createdBy')"
                                            :content="survey.get('createdBy').get('name')" trigger="hover"
                                            placement="top">
                                            <img width="30px" height="30px"
                                                style="display:inline-block;  border-radius: 100px; border:1px solid #fff;"
                                                :src="survey.get('createdBy').get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')" />
                                        </va-tooltip>
                                    </td>

                                    <td v-if="getScreenWidth > 425"
                                        :class="{rtlTd: getSystemLanguage != 'english', fixed_td: true}">
                                        {{new Date(survey.createdAt).getFullYear() + '-' + parseInt(1 +
                                        new
                                        Date(survey.createdAt).getMonth())+ '-' + new
                                        Date(survey.createdAt).getDate()}}

                                    </td>
                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <va-lozenge v-if="survey.get('status') == 'completed'" type="success" bold>
                                            {{ _(survey.get('status')) }}</va-lozenge>
                                        <va-lozenge v-else-if="survey.get('status') == 'running'" type="primary" bold>
                                            {{ _(survey.get('status')) }}
                                        </va-lozenge>
                                        <va-lozenge v-else-if="survey.get('status') == 'rejected'" type="danger" bold>
                                            {{ _(survey.get('status')) }}
                                        </va-lozenge>
                                        <va-lozenge v-else-if="survey.get('status') == 'pending'" type="warning" bold>
                                            {{ _(survey.get('status')) }}
                                        </va-lozenge>
                                        <va-lozenge v-else-if="survey.get('status') == 'paused'" type="purple" bold>
                                            {{ _(survey.get('status')) }}
                                        </va-lozenge>
                                    </td>
                                    <td v-if="getScreenWidth > 425 && user && !user.get('roles').includes('guest')"
                                        :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <va-lozenge v-if="survey.get('survey_design_status') == 'approved'"
                                            type="success" bold>
                                            {{ _(survey.get('survey_design_status')) }}</va-lozenge>

                                        <va-lozenge v-else-if="survey.get('survey_design_status') == 'rejected'"
                                            type="danger" bold>
                                            {{ _(survey.get('survey_design_status')) }}
                                        </va-lozenge>
                                        <va-lozenge v-else-if="survey.get('survey_design_status') == 'pending'"
                                            type="warning" bold>
                                            {{ _(survey.get('survey_design_status')) }}
                                        </va-lozenge>
                                    </td>
                                    <td v-if="user && !user.get('roles').includes('guest')" style="overflow:visible"
                                        :class="{rtlTd: getSystemLanguage != 'english', fixed_td: true}">
                                        <va-dropdown ref="actionsDropDown">
                                            <div slot="trigger">
                                                <va-icon type="ellipsis-h" margin="0 0 0 7px"></va-icon>
                                            </div>
                                            <li
                                                v-if="survey.get('status') == 'running' || survey.get('status') == 'completed'">
                                                <a
                                                    @click="navigate('/surveys/' + $route.params.scope + '/' + $route.params.category + '/' + survey.get('class_name').slice(5) + '/list?perPage=10', survey)">{{_("Submissions")}}</a>
                                            </li>
                                            <li
                                                v-if="survey.get('status') != 'completed' && user.get('roles').includes('admin') || (user.get('roles').includes('manager') && g_canEditForm(survey)) || (user.get('roles').includes('survey-approver') && g_isFormDesignApprover(survey))">
                                                <a
                                                    @click="navigate('/surveys/' + $route.params.scope + '/' + $route.params.category + '/form/' + survey.id, survey)">{{_("Edit Form")}}</a>
                                            </li>
                                            <li>
                                                <a
                                                    @click="navigate('/surveys/' + survey.id, survey)">{{_("Preview")}}</a>
                                            </li>
                                            <li>
                                                <a v-if="survey.get('status') == 'paused'  && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor'))"
                                                    @click="resumeSurvey(survey)">{{_("Resume")}}</a>
                                            </li>
                                            <li>
                                                <a v-if="(survey.get('status') == 'running' || survey.get('status') == 'paused')  && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor'))"
                                                    @click="completeSurvey(survey)">{{_("Complete")}}</a>
                                            </li>
                                            <li>
                                                <a v-if="survey.get('status') == 'running'  && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor'))"
                                                    @click="pauseSurvey(survey)">{{_("Pause")}}</a>
                                            </li>
                                            <li>
                                                <a v-if="!survey.get('is_form_public_available') && (survey.get('status') == 'running' || survey.get('status') == 'completed')  && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                                                    @click="shareSurveyFormToPublic(survey)">{{_("Share Form")}}</a>
                                            </li>
                                            <li>
                                                <a v-if="!survey.get('is_submissions_public_available') && (survey.get('status') == 'running' || survey.get('status') == 'completed')  && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                                                    @click="shareSurveySubmissionsToPublic(survey)">{{_("Share Submissions")}}</a>
                                            </li>

                                            <li>
                                                <a v-if="(survey.get('is_submissions_public_available') || survey.get('is_form_public_available')) && (survey.get('status') == 'running' || survey.get('status') == 'completed')  && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                                                    @click="getSharedSurveyLink(survey)">{{_("Get public Links")}}</a>
                                            </li>

                                            <li>
                                                <a v-if="survey.get('is_form_public_available') && (survey.get('status') == 'running' || survey.get('status') == 'completed')  && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                                                    @click="removePublicFormLink(survey)">{{_("Remove public form link")}}</a>
                                            </li>

                                            <li>
                                                <a v-if="survey.get('is_submissions_public_available') && (survey.get('status') == 'running' || survey.get('status') == 'completed')  && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                                                    @click="removePublicSubmissionsLink(survey)">{{_("Remove public submissions link")}}</a>
                                            </li>

                                            <li
                                                v-if="survey.get('status') =='pending' && survey.get('survey_design_status') =='approved' && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor'))">
                                                <a @click="publishSurvey(survey)">{{_("Publish")}}</a>
                                            </li>
                                            <li>
                                                <a v-if="survey.get('survey_design_status') == 'pending' && (user.get('roles').includes('admin') || (user.get('roles').includes('manager') && g_canEditForm(survey)) || (user.get('roles').includes('survey-approver') && g_isFormDesignApprover(survey)))"
                                                    @click="approveObject(survey)">{{_("Approve")}}</a>
                                            </li>
                                            <li>
                                                <a v-if="survey.get('survey_design_status') == 'pending' && (user.get('roles').includes('admin') || (user.get('roles').includes('manager') && g_canEditForm(survey)) || (user.get('roles').includes('survey-approver') && g_isFormDesignApprover(survey)))"
                                                    @click="rejectObject(survey)">{{_("Reject")}}</a>
                                            </li>
                                            <li>
                                                <a v-if="user.get('roles').includes('admin')"
                                                    @click="deleteObject(survey)">{{_("Delete")}}</a>
                                            </li>
                                        </va-dropdown>
                                    </td>
                                </tr>
                                <tr v-if="allSurveysCount == 0">
                                    <td style="text-align:center" :colspan="7">
                                        {{ _("No survey available") }}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </va-table>

                </va-column>
            </va-row>

            <va-row :gutter="12">

                <va-column :lg="12" :sm="12">
                    <div style="display: flex">
                        <!-- <v-page :class="{no_click: getSurvyesCount==0}" :key="$route.path" :total-row="getSurvyesCount"
                            @page-change="paginate"></v-page> -->

                        <my-page :key="$route.path" :class="{no_click: getSurvyesCount == 0}"
                            :total-row="getSurvyesCount" @page-change="paginate" :pageSizeMenu="[10, 20, 50, 100]">
                        </my-page>

                        <va-button style="margin-left: 10px" @click.native="paginate({pageNumber: page})">
                            <va-icon type="sync-alt"></va-icon>
                        </va-button>
                    </div>
                </va-column>

            </va-row>

        </div>

        <va-modal :title="_('Survey Public Links')" ref="publicFormLinkModal" @confirm="closeModal"
            :backdrop-clickable="true" @hide="clearPublicLinks">
            <div slot="body" style="color: blue; word-break: break-all">
                <div v-if="currentFormLink != ''">
                    <span class="field_label">{{ _('Public Form') }}</span>
                    <span>{{ currentFormLink }}</span>
                </div>
                <div v-if="currentSubmissionsLink != ''">
                    <span class="field_label">{{ _('Submissions Link') }}</span>
                    <span>{{ currentSubmissionsLink }}</span>
                </div>
            </div>
        </va-modal>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import Category from '../Category.vue'
    import MyPage from '../../components/Page.vue'

    export default {

        components: {
            Category,
            'my-page': MyPage
        },

        data() {
            return {
                page: 1,
                allSurveysCount: 0,
                perPageSurveys: [],

                categoryName: '',
                categoryNamePashto: '',
                categoryNameDari: '',
                currentCategory: {},
                disableCatDeleteBtn: false,

                parentRoute: '',

                filterValue: '',
                filterValueArr: [],
                filterCondition: '',
                filterFromDate: '',
                filterToDate: '',
                dateRangeFilterLabel: '',
                filterType: false,

                dropDown: 'first',
                filters: [],
                filterFields: [],
                filterTitle: '',

                currentFilter: {},
                searchString: '',
                errorMessage: '',

                uploaderName: '',
                fetchedUsers: [],
                filterUsers: [],

                statusLoading: false,
                searchBarKey: '',
                catKey: '',

                // sharing
                currentSubmissionsLink: '',
                currentFormLink: '',

                // cateogry
                category: null,
                currentDepartment: null,
                makeCategoryModalVisible: false,
                disableScreen: false,
                category_key: '',
                categoryDepartment: null,

            };
        },

        watch: {
            async '$route'(to, from) {
                this.page = 1
                await this.fetchings()
            },

            isSearchingContent(val) {
                if (!val) this.fetchSurveys(1)
            },
        },


        computed: {
            ...mapGetters(['user', 'getCurrentCategory', 'getCurrentDepartment', 'getDirectionStatus', 'getSystemLanguage', 'getSearchedResult', 'isSearchingContent', 'getSearchError']),

            getCategory() {
                return this.category || this.getCurrentCategory
            },


            getScreenWidth() {
                if (window != null && window.screen != null && window.screen.width != null) {
                    return window.screen.width;
                }
                return 426
            },

            getSurvyes() {
                if (this.getSearchError == '' && this.isSearchingContent) {
                    return this.getSearchedResult
                }
                else {
                    return this.perPageSurveys
                }
            },

            getSurvyesCount() {
                if (this.getSearchError == '' && this.isSearchingContent) {
                    return this.getSearchedResult.length
                }
                else {
                    return this.allSurveysCount
                }
            },

        },

        methods: {
            ...mapActions(['setCurrentFormToState', 'fetchCurrentCategory', 'fetchDepartmentCategories', 'fetchDepartments', 'fetchGlobalCategories', 'setRouter', 'updateCurrentCategory', 'approveEntity', 'rejectEntity']),

            // start cateogry
            hideCategoryModal() {
                this.makeCategoryModalVisible = false
            },

            setDisableScreenValue(val) {
                this.disableScreen = val
            },

            showCategoryModal() {
                this.makeCategoryModalVisible = true
                this.categoryDepartment = this.getCategory.get('department')
            },
            // end category


            closeModal() {
                this.$refs.publicFormLinkModal.close();
                this.currentSubmissionsLink = '';
                this.currentFormLink = '';
            },

            async removePublicSubmissionsLink(survey) {
                this.$store.commit('setLoading', true)
                if (survey != null) {
                    if (survey.get('is_submissions_public_available')) {
                        survey.set('is_submissions_public_available', false)
                        survey.set('public_submissions_link', '')
                        await survey.save()
                            .then(async res => {
                                await this.fetchSurveys(this.page)
                                await this.fetchSurveysCount()
                                this.$store.commit('setLoading', false)
                            }).catch(e => {
                                this.$store.commit('setLoading', false)
                                this.$notify({
                                    group: 'foo',
                                    text: this._('An error accured while removing submissions public link'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                    } else {
                        this.$store.commit('setLoading', false)
                    }
                } else {
                    this.$store.commit('setLoading', false)
                }
            },

            async removePublicFormLink(survey) {
                this.$store.commit('setLoading', true)
                if (survey != null) {
                    if (survey.get('is_form_public_available')) {
                        survey.set('is_form_public_available', false)
                        survey.set('public_form_link', '')
                        await survey.save()
                            .then(async res => {
                                await this.fetchSurveys(this.page)
                                await this.fetchSurveysCount()
                                this.$store.commit('setLoading', false)
                            }).catch(e => {
                                this.$store.commit('setLoading', false)
                                this.$notify({
                                    group: 'foo',
                                    text: this._('An error accured while removing survey form public link'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                    } else {
                        this.$store.commit('setLoading', false)
                    }
                } else {
                    this.$store.commit('setLoading', false)
                }

            },

            clearPublicLinks() {
                this.currentSubmissionsLink = '';
                this.currentFormLink = '';
            },

            async shareSurveyFormToPublic(survey) {
                this.$store.commit('setLoading', true)
                survey.set('is_submissions_public_available', true)
                survey.set('is_form_public_available', true)
                survey.set('public_submissions_link', 'https://neis.nepa.gov.af/surveys/public/' + this.$route.params.scope + '/' + this.$route.params.category + '/' + survey.get('class_name').slice(5) + '/' + survey.id + '/list')
                survey.set('public_form_link', 'https://neis.nepa.gov.af/surveys/public/' + this.$route.params.scope + '/' + this.$route.params.category + '/' + survey.get('class_name').slice(5) + '/' + survey.id + '/new')

                await survey.save().then(async res => {
                    this.currentSubmissionsLink = res.get('public_submissions_link')
                    this.currentFormLink = res.get('public_form_link')
                    this.$store.commit('setLoading', false)
                    this.$refs.publicFormLinkModal.open();
                    this.$notify({
                        group: 'foo',
                        text: this._('Survey form was shared'),
                        duration: 4000,
                        position: 'top left',
                        type: 'success'
                    });
                }).catch(e => {
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        text: this._('An error accured while publishing survey to public'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                })
            },

            async shareSurveySubmissionsToPublic(survey) {
                this.$store.commit('setLoading', true)
                survey.set('is_submissions_public_available', true)
                survey.set('public_submissions_link', 'https://neis.nepa.gov.af/surveys/public/' + this.$route.params.scope + '/' + this.$route.params.category + '/' + survey.get('class_name').slice(5) + '/' + survey.id + '/list')
                await survey.save().then(async res => {
                    this.currentSubmissionsLink = res.get('public_submissions_link')
                    this.$store.commit('setLoading', false)
                    this.$refs.publicFormLinkModal.open();
                    this.$notify({
                        group: 'foo',
                        text: this._('Survey submissions link was generated'),
                        duration: 4000,
                        position: 'top left',
                        type: 'success'
                    });
                }).catch(e => {
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        text: this._('An error accured while generating survey submissions link'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                })

            },

            getSharedSurveyLink(survey) {
                if (survey != null) {
                    if (survey.get('is_form_public_available')) {
                        this.currentFormLink = survey.get('public_form_link');
                    }
                    if (survey.get('is_submissions_public_available')) {
                        this.currentSubmissionsLink = survey.get('public_submissions_link')
                    }
                }

                this.$refs.publicFormLinkModal.open();
            },

            async publishSurvey(survey) {
                let self = this
                self.VaModal.confirm({
                    title: self._('Alert'),
                    message: self._('Please make sure your form design is ready'),
                    type: 'warning',
                    async onConfirm() {
                        self.$store.commit('setLoading', true)
                        if (survey.get('survey_submitters') && survey.get('survey_submitters').length != 0) {
                            let className = 'Data_' + survey.get('label_english').slugify()

                            let q = new Parse.Query('Form')
                            q.equalTo('class_name', className)
                            let result = await q.first();

                            if (result) {
                                className + Date.now().toString()
                            }
                            var NewClass = Parse.Object.extend(className);
                            var newEntry = new NewClass();




                            let myObject = {}

                            myObject['status'] = 'pending';
                            myObject['category'] = self.getCategory;
                            myObject['department'] = self.currentDepartment;
                            myObject['form'] = survey;
                            myObject['submission_language'] = '';
                            myObject['createdBy'] = self.user
                            myObject['approvalBy'] = self.user
                            survey.get('layout').forEach(field => {
                                if (field.type !== 'heading' && field.type !== 'description') {

                                    if (field.type == 'text') {
                                        if (field.fieldType == 'number') {
                                            myObject[field.fieldDatabaseName] = 0
                                        } else {
                                            myObject[field.fieldDatabaseName] = ''
                                        }
                                    } else if (field.type == 'textarea' || field.type == 'single-option') {
                                        myObject[field.fieldDatabaseName] = ''
                                    } else if (field.type == 'checkbox') {
                                        myObject[field.fieldDatabaseName] = false
                                    } else if (field.type == 'select' || field.type == 'attachment') {
                                        if (field.multiple)
                                            myObject[field.fieldDatabaseName] = []
                                        else myObject[field.fieldDatabaseName] = ''
                                    } else if (field.type == 'date') {
                                        if (field.isTime) {
                                            myObject[field.fieldDatabaseName] = 0
                                        } else {
                                            myObject[field.fieldDatabaseName] = new Date()
                                        }
                                    } else if (field.type == 'multiple-option' || field.type == 'multiple-geolocation') {
                                        myObject[field.fieldDatabaseName] = []
                                    } else if (field.type == 'single-geolocation') {
                                        myObject['latitude'] = 0;
                                        myObject['longitude'] = 0;
                                    }
                                }
                            })

                            await newEntry.save(myObject).then(async item => item.destroy().then(async r => {
                                self.$store.commit('setLoading', true)
                                await self.fetchSurveys(self.page)
                                await self.fetchSurveysCount()
                                survey.set('status', 'running')
                                survey.set('class_name', className)
                                await survey.save()

                                // activity
                                self.createActivity(survey, 'publishSurvey', null)


                                // notification for designer
                                if (self.user.id != survey.get('createdBy').id) {
                                    self.createActivity(survey, 'publishDesignSurvey', survey.get('createdBy'))

                                }
                                if (survey.get('survey_submitters'))
                                    survey.get('survey_submitters').forEach(user => {
                                        self.createActivity(survey, 'submitterAssignment', user)
                                    })

                                if (survey.get('survey_submission_approvers'))
                                    survey.get('survey_submission_approvers').forEach(user => {
                                        self.createActivity(survey, 'approvalAssignment', user)
                                    })

                                // send notif to design approver to let them know that thier design approved form was publishd
                                if (survey.get('survey_design_approvers'))
                                    survey.get('survey_design_approvers').forEach(user => {
                                        self.createActivity(survey, 'publishApprovedDesign', user)

                                    })

                                if (survey.get('shared_with'))
                                    survey.get('shared_with').forEach(user => {
                                        self.createActivity(survey, 'shareWithGuest', user)

                                    })

                                if (survey.get('approvalBy')) {
                                    self.createActivity(survey, 'PublishApprovalBy', survey.get('approvalBy'))
                                }


                                self.$notify({
                                    group: 'foo',
                                    text: self._('Survey was published'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'success'
                                });
                            }).catch(e => {
                                self.$store.commit('setLoading', false)
                                self.$notify({
                                    group: 'foo',
                                    title: self._('System Error'),
                                    text: self._("An error accured while publishing survey"),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            }));
                        } else {
                            self.$store.commit('setLoading', false)
                            self.$notify({
                                group: 'foo',
                                text: self._("No submitter found"),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        }
                    }
                })
            },

            createActivity(survey, action, to) {
                var url
                if (survey.get('class_name')) url = this.$route.path + '/' + survey.get('class_name').slice(5) + '/list'
                else url = this.$route.path
                this.g_newActivity({
                    label_english: survey.get('label_english'),
                    label_pashto: survey.get('label_pashto'),
                    label_dari: survey.get('label_dari'),
                    type: 'survey',
                    action: action,
                    url: url,
                    createdBy: this.user.id,
                    to: to,
                    category: this.getCategory,
                    department: this.currentDepartment,
                    class: 'Form',
                    reference_id: survey.id
                })
            },

            completeSurvey(survey) {
                var self = this
                self.VaModal.confirm({
                    title: self._('Alert'),
                    message: self._('Please make sure if you want to mark the selected survey as completed'),
                    type: 'warning',
                    onConfirm() {
                        self.$store.commit('setLoading', true)
                        survey.set('status', 'completed')
                        survey.save()
                            .then(async res => {
                                self.$store.commit('setLoading', true)
                                await self.fetchSurveys(self.page)
                                await self.fetchSurveysCount()
                                self.$notify({
                                    group: 'foo',
                                    text: self._('Survey was marked as completed'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'success'
                                });

                                self.createActivity(survey, 'completeSurvey', null)


                            }).catch(e => {
                                self.$notify({
                                    group: 'foo',
                                    title: self._('System Error'),
                                    text: self._('An error was encountered while completing survey'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                    }
                })
            },

            pauseSurvey(survey) {
                var self = this
                self.VaModal.confirm({
                    title: self._('Alert'),
                    message: self._('Please make sure if you want to pause the selected survey'),
                    type: 'warning',
                    onConfirm() {
                        self.$store.commit('setLoading', true)
                        survey.set('status', 'paused')
                        survey.save()
                            .then(async res => {
                                self.$store.commit('setLoading', true)
                                await self.fetchSurveys(self.page)
                                await self.fetchSurveysCount()
                                self.$notify({
                                    group: 'foo',
                                    text: self._('Survey was paused'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'success'
                                });

                                self.createActivity(survey, 'pauseSurvey', null)

                            }).catch(e => {
                                self.$notify({
                                    group: 'foo',
                                    title: self._('System Error'),
                                    text: self._('An error was encountered while pausing survey'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                    }
                })
            },

            resumeSurvey(survey) {
                var self = this
                self.VaModal.confirm({
                    title: self._('Alert'),
                    message: self._('Please make sure if you want to resume the selected survey'),
                    type: 'warning',
                    onConfirm() {
                        self.$store.commit('setLoading', true)
                        survey.set('status', 'running')
                        survey.save()
                            .then(async res => {
                                self.$store.commit('setLoading', true)
                                await self.fetchSurveys(self.page)
                                await self.fetchSurveysCount()
                                self.$notify({
                                    group: 'foo',
                                    text: self._('Survey was resumed'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'success'
                                });

                                self.createActivity(survey, 'resumeSurvey', null)
                            }).catch(e => {
                                self.$notify({
                                    group: 'foo',
                                    title: self._('System Error'),
                                    text: self._('An error was encountered while resuming survey'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                    }
                })
            },

            async deleteObject(survey) {
                this.g_deleteObject(survey)
                    .then(async result => {
                        if (result) {
                            this.$store.commit('setLoading', true)
                            await this.fetchSurveys(this.page)
                            await this.fetchSurveysCount()
                        }

                    }).catch(e => {

                    })
            },

            // approved
            approveObject(survey) {
                this.g_approveObject(survey)
                    .then(async result => {
                        this.$store.commit('setLoading', true)

                        await this.fetchSurveys(this.page)
                        await this.fetchSurveysCount()
                    }).catch(e => {

                    })
            },

            rejectObject(survey) {
                this.g_rejectObject(survey)
                    .then(async result => {
                        this.$store.commit('setLoading', true)
                        await this.fetchSurveys(this.page)
                        await this.fetchSurveysCount()
                    }).catch(e => {

                    })
            },


            async fetchSurveys(pageNum) {
                var conditions = [];
                conditions.push(new Parse.Query('Form').equalTo('is_enabled', true))

                if (this.user) {
                    conditions.push(new Parse.Query('Form').equalTo('is_enabled', true))

                    if (this.user.get('roles').includes('guest')) {
                        conditions.push(new Parse.Query('Form').equalTo('shared_with', this.user))
                        conditions.push(new Parse.Query('Form').equalTo('survey_design_status', 'approved'))
                        conditions.push(new Parse.Query('Form').notEqualTo('status', 'pending'))
                    } else {
                        conditions.push(new Parse.Query('Form').equalTo('category', this.getCategory))
                        conditions.push(new Parse.Query('Form').equalTo('department', this.currentDepartment))
                    }

                    if (!this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes('survey-editor') && !this.user.get('roles').includes('guest')) {
                        var orTemp = [];
                        orTemp.push(new Parse.Query('Form').equalTo('createdBy', this.user))
                        orTemp.push(new Parse.Query('Form').equalTo('approvalBy', this.user))

                        if (this.user.get('roles').includes('survey-approver')) {
                            orTemp.push(new Parse.Query('Form').equalTo('survey_design_approvers', this.user))
                        }

                        if (this.user.get('roles').includes('submission-approver')) {
                            var submissinTemp = [];
                            submissinTemp.push(new Parse.Query('Form').equalTo('survey_submission_approvers', this.user))
                            submissinTemp.push(new Parse.Query('Form').notEqualTo('status', 'pending'))
                            orTemp.push(Parse.Query.and(...submissinTemp))
                        }

                        if (this.user.get('roles').includes('submitter')) {
                            var submitterTemp = [];
                            submitterTemp.push(new Parse.Query('Form').equalTo('survey_submitters', this.user))
                            submitterTemp.push(new Parse.Query('Form').notEqualTo('status', 'pending'))
                            orTemp.push(Parse.Query.and(...submitterTemp))
                        }

                        if (this.user.get('roles').includes('survey-viewer')) {
                            orTemp.push(new Parse.Query('Form').equalTo('survey_design_status', 'approved'))
                        }
                        if (orTemp.length == 0) orTemp.push(new Parse.Query('Form').notEqualTo('objectId', ''))
                        conditions.push(Parse.Query.or(...orTemp))
                    }

                    var limit = 10;
                    if (this.$route && this.$route.query && this.$route.query['perPage']) {
                        limit = parseInt(this.$route.query['perPage'])
                    } else {
                        limit = 10
                    }


                    var mainQuery = Parse.Query.and(...conditions);

                    mainQuery.skip((pageNum - 1) * limit)
                    mainQuery.limit(limit)
                    mainQuery.descending('createdAt')
                    mainQuery.select("design_require_approval", "submission_require_approval", "survey_design_approvers", "survey_submission_approvers", "survey_submitters", "category", "department", "public_form_link", "is_form_public_available", "public_submissions_link", "is_submissions_public_available", "survey_design_status", "status", "label_english", "label_pashto", "label_dari", "createdBy", "layout", "class_name", "approvalBy", "shared_with");
                    mainQuery.include('createdBy')
                    mainQuery.include('survey_design_approvers')
                    mainQuery.include('survey_submission_approvers')
                    mainQuery.include('survey_submitters')
                    mainQuery.include('category')
                    mainQuery.include('department')
                    mainQuery.include('approvalBy')
                    mainQuery.include('shared_with')

                    this.perPageSurveys = []
                    this.perPageSurveys = await mainQuery.find();
                    this.$store.commit('setLoading', false)
                }
            },

            async fetchSurveysCount() {
                var conditions = [];
                if (this.user) {
                    conditions.push(new Parse.Query('Form').equalTo('is_enabled', true))

                    if (this.user.get('roles').includes('guest')) {
                        conditions.push(new Parse.Query('Form').equalTo('shared_with', this.user))
                        conditions.push(new Parse.Query('Form').equalTo('survey_design_status', 'approved'))
                        conditions.push(new Parse.Query('Form').notEqualTo('status', 'pending'))
                    } else {
                        conditions.push(new Parse.Query('Form').equalTo('category', this.getCategory))
                        conditions.push(new Parse.Query('Form').equalTo('department', this.currentDepartment))
                    }

                    if (!this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes('survey-editor') && !this.user.get('roles').includes('guest')) {
                        var orTemp = [];
                        orTemp.push(new Parse.Query('Form').equalTo('createdBy', this.user))
                        orTemp.push(new Parse.Query('Form').equalTo('approvalBy', this.user))

                        if (this.user.get('roles').includes('survey-approver')) {
                            orTemp.push(new Parse.Query('Form').equalTo('survey_design_approvers', this.user))
                        }

                        if (this.user.get('roles').includes('submission-approver')) {
                            var submissinTemp = [];
                            submissinTemp.push(new Parse.Query('Form').equalTo('survey_submission_approvers', this.user))
                            submissinTemp.push(new Parse.Query('Form').notEqualTo('status', 'pending'))
                            orTemp.push(Parse.Query.and(...submissinTemp))
                        }

                        if (this.user.get('roles').includes('submitter')) {
                            var submitterTemp = [];
                            submitterTemp.push(new Parse.Query('Form').equalTo('survey_submitters', this.user))
                            submitterTemp.push(new Parse.Query('Form').notEqualTo('status', 'pending'))
                            orTemp.push(Parse.Query.and(...submitterTemp))
                        }

                        if (this.user.get('roles').includes('survey-viewer')) {
                            orTemp.push(new Parse.Query('Form').equalTo('survey_design_status', 'approved'))
                        }
                        if (orTemp.length == 0) orTemp.push(new Parse.Query('Form').notEqualTo('objectId', ''))
                        conditions.push(Parse.Query.or(...orTemp))
                    }


                    var mainQuery = Parse.Query.and(...conditions);
                    this.allSurveysCount = await mainQuery.count()
                }
            },


            async paginate(page) {
                this.page = page.pageNumber
                this.$store.commit('setLoading', true)
                if (this.getSearchError == '' && this.isSearchingContent) {
                    await this.$refs.searchBar.search()
                } else {
                    await this.fetchSurveys(page.pageNumber)
                }
            },

            navigate(to, object) {
                this.setCurrentFormToState(object)
                this.$router.push(to);
            },

            async fetchings() {
                this.$store.commit("setLoading", true);
                this.category = this.getCurrentCategory
                this.currentDepartment = this.getCurrentDepartment
                await this.fetchSurveysCount()
                await this.fetchSurveys(1)
                this.$store.commit("setLoading", false);
                this.category_key = Date.now().toString()
            }

        },

        async mounted() {
            await this.fetchings()
        }
    };
</script>

<style>
    .fixed_td .va-table .td {
        max-width: 100px !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
    }

    .dropdown1 .va-dropdown-menu {
        left: inherit !important;
        top: inherit !important;
    }

    .dropdown1 .va-dropdown-con {
        position: inherit;
    }
</style>